module.exports = __webpack_public_path__ + "img/project1_small.db5a6873.jpg";